import React from 'react';
import Chip from '@mui/material/Chip';
export default function ChipStatus({
  status
}) {
  return <Chip label={status} variant={status} />;
}